import ShippingProvider from 'components/Orders/package/shippingProvider';
import React from 'react';

import CreateShipping from './create';

export default function CreateShippingPage() {
  return (
    <ShippingProvider>
      <CreateShipping />
    </ShippingProvider>
  );
}
